export default "__VITE_ASSET__DuFeh5P$__"